import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { Button, Row, Col } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { resetPassword, forwardResetPwd, DO_RESET_PWD_SUCCESS, DO_RESET_PWD_FAIL } from '../../actions/login/index';
import Loading from '../common/Loading';
import {minLength8, verifyForm} from '../../components/common/access-form-validation';
import { closeModal } from '../../actions/index';
import {commonRenderInput} from "../common/access-form";


class AccountConfigForm extends Component {

  state = {
    isEditName: false,
    oldPwdDisplay: false,
    newPwdDisplay: false,
    confirmPwdDisplay: false,
    tipMsg: null
  }

  formSubmit = (values) => {
    const { resetPassword, authToken, accountInfo } = this.props;
    const newPassword = values['newPwd'];
    let tipMsg = null;
    if (newPassword !== values['contirmPwd']) {
      tipMsg = 'The new password is inconsistent with the confirmed password.';
    // } else if (!this.passwordFormatTest(newPassword)) {
    //   tipMsg = 'The password should contain Capital letter and at least five digitals eight.';
    } else {
      resetPassword(authToken, accountInfo.seq, values['oldPwd'], newPassword);
    }

    this.setState({
      tipMsg: tipMsg
    });
  }

  passwordFormatTest = (pwd) => {
    const regUpper = /[A-Z]/;
    const regLower = /[a-z]/;
    const regNum = /[0-9]/;
    let ret = true;

    if (pwd.length < 8) {
      ret = false;
    }

    if (ret && !regUpper.test(pwd)) {
      ret = false;
    }

    if (ret && !regLower.test(pwd)) {
      ret = false;
    }

    if (ret && !regNum.test(pwd)) {
      ret = false;
    }

    return ret;
  }

  toggleOldDisplayPwd = () => {
    const { oldPwdDisplay } = this.state;
    this.setState({
      oldPwdDisplay: !oldPwdDisplay
    })
  }

  toggleNewDisplayPwd = () => {
    const { newPwdDisplay } = this.state;
    this.setState({
      newPwdDisplay: !newPwdDisplay
    })
  }

  toggleConfirmDisplayPwd = () => {
    const { confirmPwdDisplay } = this.state;
    this.setState({
      confirmPwdDisplay: !confirmPwdDisplay
    })
  }

  renderResetPwdForm = () => {
    const { handleSubmit, status, errMsg, verifyFormPass, closeModal } = this.props;
    const { oldPwdDisplay, newPwdDisplay, confirmPwdDisplay, tipMsg } = this.state;
    const msg = tipMsg ? tipMsg : errMsg;
    let oldPwdType = 'password', newPwdType = 'password', confrimPwdType = 'password';
    let oldPwdClass = 'icon-btn-password-hide-n', newPwdClass = 'icon-btn-password-hide-n', confrimPwdClass = 'icon-btn-password-hide-n';
    if (oldPwdDisplay) {
      oldPwdType = 'text';
      oldPwdClass = 'icon-btn-password-show-n';
    }
    if (newPwdDisplay) {
      newPwdType = 'text';
      newPwdClass = 'icon-btn-password-show-n';
    }
    if (confirmPwdDisplay) {
      confrimPwdType = 'text';
      confrimPwdClass = 'icon-btn-password-show-n';
    }

    let alertMsg = (
      <div className='area-alert-msg'><label>&nbsp;</label></div>
    );

    if (status === DO_RESET_PWD_FAIL || tipMsg) {
      alertMsg = (
        <div className='area-alert-msg'><label>{msg}</label></div>
      );
    } else if (status === DO_RESET_PWD_SUCCESS) {
      alertMsg = (
        <div className='area-tip-msg'><label>{"Change new password success."}</label></div>
      );
    }

    let btnSubmit = (
      <>
        <Button variant="primary" size="lg" bsPrefix='btn btn-close' block onClick={()=>closeModal(null)}>Cancel</Button>
        <Button type="submit" variant="primary" size="lg" bsPrefix='btn btn-save' disabled={!verifyFormPass} block>Save</Button>
      </>
    );

    return (
      <form className='reset-pwd-form' onSubmit={handleSubmit(this.formSubmit)}>
        <div className='area-form-field'>
          <Row>
            <Col sm={12}>
              <div className='area-form-label'><span className='need-star-label'>*</span>Current Password</div>
            </Col>
            <Col sm={11}>
              <Field name="oldPwd" type={oldPwdType} component={commonRenderInput}  placeholder="Please input current password"
               props={{
                  disabled: false,
                }} />
            </Col>
            <Col sm={1}>
              <div className='area-form-icon'><span className={oldPwdClass} onClick={this.toggleOldDisplayPwd}></span></div>
            </Col>
            <Col sm={12}>
              <div className='area-form-label'><span className='need-star-label'>*</span>New Password</div>
            </Col>
            <Col sm={11}>
              <Field name="newPwd"
                     type={newPwdType}
                     component={commonRenderInput}
                     placeholder="Please input new password"
                     validate={minLength8}
                     props={{
                       disabled: false,
                     }}
              />
            </Col>
            <Col sm={1}>
              <div className='area-form-icon'><span className={newPwdClass} onClick={this.toggleNewDisplayPwd}></span></div>
            </Col>
            <Col sm={12}>
              <div className='area-form-label'><span className='need-star-label'>*</span>Confirm Password</div>
            </Col>
            <Col sm={11}>
              <Field name="contirmPwd" type={confrimPwdType} component={commonRenderInput} placeholder="Please input new password again"
                props={{
                  disabled: false,
                }} />
            </Col>
            <Col sm={1}>
              <div className='area-form-icon'><span className={confrimPwdClass} onClick={this.toggleConfirmDisplayPwd}></span></div>
            </Col>
          </Row>
        </div>        
        { alertMsg}
        <div className='area-submit-btn'>
          {btnSubmit}
        </div>
      </form>
    )
  }

  render() {
    const { forgotPwdLoading } = this.props;
    const formContent = this.renderResetPwdForm();

    return (
      <div className='area-account-config-form form-custom'>
        { formContent}
        <Loading loading={forgotPwdLoading} center={true}></Loading>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const verifyFormPass = verifyForm(state.form['AccountConfigForm']);
  const accountInfo = state.loginReducers.accountInfo ? state.loginReducers.accountInfo : {};

  let ret = {
    authToken: state.loginReducers.authToken,
    accountInfo: accountInfo,
    status: state.loginReducers.status,
    forgotPwdLoading: state.loginReducers.forgotPwdLoading,
    errMsg: state.loginReducers.errMsg,
    showResetPwd: state.loginReducers.showResetPwd,
    verifyFormPass: verifyFormPass,
    formValues: getFormValues('AccountConfigForm')(state)
  };

  let initialValues = {};
  initialValues['name'] = accountInfo['name'];
  initialValues['email'] = accountInfo['email'];
  ret['initialValues'] = initialValues;

  return ret;
};

AccountConfigForm = reduxForm({
  form: 'AccountConfigForm',  // a unique identifier for this form
})(AccountConfigForm)

export default withRouter(connect(
  mapStateToProps,
  { resetPassword, forwardResetPwd, closeModal }
)(AccountConfigForm));